import React      from 'react';
import ReactDom   from 'react-dom';

import Const      from 'fw_const';
import Utils      from 'utils';

import ReactWordcloud   from 'react-wordcloud';

// -------------------------------------------------------


class ProfilingWordcloud extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
    };
  }
  // -------------------------------------------------------
  
  shouldComponentUpdate(nextProps, nextState){
    try {
      if( nextProps.wordcloud == this.state.wordcloud ){
        return false;
      } else {
        this.setState({ wordcloud: nextProps.wordcloud });
        return true;
      }
    } catch(e) {
      return true;
    }
  }
  // -------------------------------------------------------
  
  render() {
    try {
      let profiling = this.props.profiling;
      
      let words = [];
      try {
        let cnt = 0;
        let json = JSON.parse(this.props.wordcloud);
        for( let i in json ){
          cnt++;
          let size = 1;
          if( cnt < 15 ) size = 2;
          if( cnt < 10 ) size = 5;
          if( cnt < 5  ) size = 10;
          
          //if( i.length >= 15 ) size = 1;
          
          if( cnt <= 30 ) words.push({ text: '#'+ i, value: size });
        }
      } catch(e) {};
      
      let options = {
        colors: ["#404654", "#a52045", "#607d8b", "#d62728", "#9467bd", "#8c564b"],
        enableTooltip: false,
        deterministic: false,
        fontSizes: [15, 30],
        padding: 1,
        rotations: 3,
        rotationAngles: [0, 0],
        transitionDuration: 0
      };
      
      return (
        <div className="wordcloud">
          
          <h5><b>{this.props.title}</b></h5>
          
          <div className="wordcloud-box">
            <div className="wordcloud-box-inner">
              {(words.length == 0) ? <div className="none">ハッシュタグを使用した投稿が見つかりませんでした</div> : null }
              
              <ReactWordcloud words={words} options={options} />
            </div>
          </div>
          
          
        </div>
      );
    } catch(e) {
      return null;
    }
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProfilingWordcloud;